import type { IUploadSource } from "../contracts/IUploadSource";
import { UploadSource } from "../domain/UploadSource";

export interface IUploadSourceMapper {
    map(uploadSourceInterface: IUploadSource): UploadSource;
}

export class UploadSourceMapper implements IUploadSourceMapper {
    map(uploadSourceInterface: IUploadSource): UploadSource {
        return new UploadSource(
            uploadSourceInterface.id,
            uploadSourceInterface.description,
            uploadSourceInterface.name,
            uploadSourceInterface.logo,
            uploadSourceInterface.logoStyle,
            uploadSourceInterface.telephone,
            uploadSourceInterface.email,
        );
    }
}
